import { render, staticRenderFns } from "./SHTableSkeleton.vue?vue&type=template&id=027e77d1&"
import script from "./SHTableSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SHTableSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports